import vuex from "vuex"
import vue from "vue"
import vapi from "vuex-rest-api"
vue.use(vuex);

const subregion = new vapi({
    baseURL: `${process.env.VUE_APP_REST}/api/subregion`,
    namespaced : true,        
    state: {
        regiones: [],
        subregionestodas: [],
        subregionesbyiniciativa: []
    }
}).get({
    action: "getSubregiones",
    path: function (obj) {
        return `list/${obj.pdet}/${obj.todas}`;
    },       
    onSuccess: (state, payload) => {        
        state.regiones = payload.data;
    }
}).get({
    action: "getSubregionestodas",
    path: function (obj) {
        return `list/${obj.pdet}/${obj.todas}`;
    },       
    onSuccess: (state, payload) => {        
        state.subregionestodas = payload.data;
    }
}).get({
    action: "getSubregionesbyiniciativa",
    path: function (obj) {
        return `subregionesbyiniciativa/`;
    },       
    onSuccess: (state, payload) => {        
        state.subregionesbyiniciativa = payload.data;
    }
}).getStore();

subregion.getters = {  
    gSubregiones : state =>  {
        return state.regiones;
    },
    gSubregionestodas : state =>  {
        return state.subregionestodas;
    },
    gSubregionesbyiniciativas : state =>  {
        return state.subregionesbyiniciativa;
    }
}

export default subregion;
